import React from "react";
import Parser from "html-react-parser";
import PropTypes from "prop-types";
import { animations } from "react-animation";
import Image from "react-bootstrap/Image";
import "./TextoYTitulo.css";
import IconoDownload from "./../../assets/img/download/Download Icon.png";

TextoYTitulo.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  text: PropTypes.string,
  mainImage: PropTypes.string,
  titleLinks: PropTypes.string,
  downloadLinks: PropTypes.array,
  borderTopColor: PropTypes.string,
  heightsm: PropTypes.bool,
};

function TextoYTitulo({
  title,
  subtitle,
  text,
  mainImage,
  titleLinks = "Descargas",
  downloadLinks,
  borderTopColor = "#001a70",
  heightsm,
  ...props
}) {
  return (
    <div style={{ animation: animations.fadeIn }}>
      {subtitle ? (
        <>
          <div className="titulo_tt">{Parser(title)}</div>
          <div className="subtitulo_tt">{Parser(subtitle)}</div>
        </>
      ) : (
        <h1 className="titulo_tt_h1">{Parser(title)}</h1>
      )}
      <div
        className={heightsm ? "h250px text_tt" : "text_tt"}
        style={{ borderTop: "3px solid " + borderTopColor }}
      >
        {Parser(text)}

        {mainImage && (
          <div className="d-flex flex-column justify-content-center">
            <Image src={mainImage} fluid rounded bsPrefix="img" />
          </div>
        )}

        {downloadLinks && (
          <div>
            <div className="downloadlinksTitle">{titleLinks}</div>
            <div className="d-flex flex-wrap justify-content-between">
              {downloadLinks.map((lnk, index) => (
                <div key={index} className="d-flex mt-3 mb-3">
                  <div>
                    <img
                      src={lnk.image ? lnk.image : IconoDownload}
                      width={40}
                      height={40}
                      alt=""
                    />
                  </div>
                  <div className="ms-2">
                    <a
                      className="downloadlinksText"
                      href={lnk.url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {lnk.name}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TextoYTitulo;